import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface BalanceSheetStateMessageProps {
  message: string;
  action?: ReactNode;
}

export default function BalanceSheetStateMessage({
  message,
  action,
}: BalanceSheetStateMessageProps) {
  return (
    <Box
      role='status'
      aria-live='polite'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        py: 8,
        textAlign: 'center',
      }}
    >
      <Typography color='text.secondary'>{message}</Typography>
      {action}
    </Box>
  );
}
